import NavItem from '@components/nav-item';
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu
} from '@components/ui/sidebar';
import { RouteItem } from '@utils/route-utils';
import { FC } from 'react';

type NavSecondaryProps = {
  item: RouteItem;
  renderGroupLabel?: boolean;
  className?: string;
};

export const NavSecondary: FC<NavSecondaryProps> = ({
  item,
  renderGroupLabel = true,
  className
}) => {
  return (
    <SidebarGroup className={className}>
      {renderGroupLabel && <SidebarGroupLabel>{item.label}</SidebarGroupLabel>}
      <SidebarGroupContent>
        <SidebarMenu>
          {item.children?.map(child => (
            <NavItem key={child.id} item={child} />
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};
